<div evasysTextOverflow [text]="text">{{ text }}</div>
